import { readAreasOfFocusCollectionsTable } from '.';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';
import { HasAreasOfFocusCollectionsLocalDatabaseContentType } from '../../types/areasOfFocusCollections';

export const checkAreasOfFocusCollectionsLocalDatabaseContent = async () => {
  console.log('hasAreasOfFocusCollectionsLocalDatabaseContent');
  const ownerId = getOwnerID() as string;
  let hasAreasOfFocusCollectionsLocalDatabaseContent = false as HasAreasOfFocusCollectionsLocalDatabaseContentType;
  if (!ownerId) {
    logger.info('Local database content NOT FOUND');
    return {
      hasAreasOfFocusCollectionsLocalDatabaseContent: false,
    };
  }

  try {
    const areasOfFocusCollectionsLocalDatabaseContent = await readAreasOfFocusCollectionsTable({ ownerId });
    logger.debug(areasOfFocusCollectionsLocalDatabaseContent, 'Local database content FOUND');
    const areasOfFocusCollectionsObject = {} as any;
    areasOfFocusCollectionsLocalDatabaseContent.forEach((element: {
      area_of_focus_collection_id: string;
      area_of_focus_collection_name: string;
      area_of_focus_collection_description: string;
      area_of_focus_collection_notes: Array<string>;
      order_of_items: Array<string>;
      selected_stack: Array<string>;
    }) => {
      areasOfFocusCollectionsObject[element.area_of_focus_collection_id] = element;
    });
    return {
      areasOfFocusCollections: areasOfFocusCollectionsObject,
      hasAreasOfFocusCollectionsLocalDatabaseContent: Boolean(areasOfFocusCollectionsLocalDatabaseContent.length),
    };
  } catch (error) {
    logger.error(error, 'Local database content NOT FOUND');
    return {
      hasAreasOfFocusCollectionsLocalDatabaseContent: false,
    };
  }
};
